import { ActionTypes } from 'redux/utils/List'

export default ActionTypes('INCIDENT_WEATHER_CONDITION_TYPE')